export default __webpack_public_path__ + "static/media/phone.6443c0b0.png";